import { jsx } from "react/jsx-runtime";
import React from "react";
var arrow_left_right_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "m22.0014 11.9998-5.6557 5.6571-1.4143-1.4142L18.1732 13H5.829l3.242 3.2429-1.4143 1.4141-5.6557-5.6571 5.6562-5.6565 1.4144 1.4141L5.829 11h12.3442l-3.2425-3.2426 1.4143-1.4141 5.6563 5.6565z" })];
};
export {
  arrow_left_right_default as default
};
